import { EMPTY_CHARACTER } from "@pulse/shared-components";
import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const SurveyRuleTargetModel = types.model("SurveyRuleTargetModel", {
  questionCode: types.string,
  gridRowCode: types.maybeNull(types.string),
});

export const createSurveyRuleTargetModel = (
  surveyRuleTarget?: SnapshotIn<typeof SurveyRuleTargetModel>,
): Instance<typeof SurveyRuleTargetModel> =>
  SurveyRuleTargetModel.create(
    surveyRuleTarget ?? {
      questionCode: EMPTY_CHARACTER,
      gridRowCode: null,
    },
  );
